/* eslint-disable max-len */
import React, { FC, useState } from 'react'
import Modal from '../common/Modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useAlert } from 'react-alert'

interface Props {
  closeCallback: VoidFunction
  updateCallback: (callback: VoidFunction) => void
  memberData: {memberId: number, name: string, labelId: number, labelGroupId: number}
  isDisplay: boolean
}

const GanttUserAssignModal: FC<Props> = (props) => {
  const {
    closeCallback,
    updateCallback,
    memberData,
    isDisplay,
  } = props

  const alert = useAlert()

  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false)

  const closeModal = () => {
    closeCallback()
  }

  const submit = () => {
    setIsLoadingSubmit(true)
    updateCallback(
      () => {
        closeCallback()
        setIsLoadingSubmit(false)
        alert.success(`${memberData.name}さんを担当者に追加しました`)
      },
    )
  }

  return (
    <Modal
      show={isDisplay}
      wrapperClass="gantt_modal w900"
      closeCallback={closeModal}
      closeable
    >
      <>
        <div
          style={{
            fontSize: "14px",
            fontWeight: "bold",
            padding: "4px 8px",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            marginBottom: "16px",
            color: "#666666",
          }}
        >
          担当者を追加
        </div>
        <div
          style={{
            padding: "4px 8px",
            marginBottom: "24px",
            color: "#666666",
          }}
        >
          <p>
            {`${memberData.name}さんは実績が記録されていますが、担当者に設定されていません。`}
          </p>
          <p>
            {`${memberData.name}さんを担当者に追加しますか？`}
          </p>
        </div>
        <div className="button_area">
          <button
            type="button"
            className="button cancel"
            onClick={() => closeCallback()}
          >
            キャンセル
          </button>
          <button
            type="button"
            className="button"
            onClick={submit}
            disabled={isLoadingSubmit}
          >
            {
              isLoadingSubmit ? (
                <>
                  <FontAwesomeIcon icon={['fas', 'spinner']} spin />
                </>
              ) : (
                <>
                  担当者に追加する
                </>
              )
            }
          </button>
        </div>
      </>
    </Modal>
  )
}

GanttUserAssignModal.defaultProps = {
}

export default GanttUserAssignModal
